import React, { Component } from 'react'
import styled from 'styled-components'
import gql from 'graphql-tag'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

import withQuery from 'containers/withQuery'

import Arrow from './Arrow'

import Icon9 from './Icon9'
import Icon10 from './Icon10'
import IconPro from './IconPro'

const stroke9 = '/images/stroke-9.jpg'
const stroke10 = '/images/stroke-10.jpg'
const strokePro = '/images/stroke-pro.jpg'

const Wrapper = styled.div`
  margin-top: 60px;
  padding: 70px 0 130px;
  background: ${props => props.theme.colors.grey.lightest};
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};

  ${media.xs`
    overflow-x: hidden;
    padding-bottom: 50px;
  `}
`

const Content = styled.div``

const Grade = styled(Link)`
  background: ${props => props.theme.colors.oxford.base};
  display: block;

  ${media.xs`
    margin-bottom: 30px;
  `}
`

const Title = styled.h2`
  font-size: 45px;
  font-weight: 600;
  text-align: center;
`

const Text = styled.p`
  text-align: center;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 60px;
  color: ${props => props.theme.colors.oxford.light};
`

const Heading = styled.h3`
  color: ${props => props.theme.colors.grey.lightest};
  font-family: ${props => props.theme.bodyFont};
  font-size: 25px;
  padding: 20px 25px;
  font-weight: 400;
  line-height: normal;
`

const ImageContainer = styled.div`
  position: relative;

  img {
    width: 95%;
    display: block;
    position: relative;
    z-index: 1;

    ${media.xs`
      width: 90%;
    `}
  }
`

const Button = styled.div`
  width: 100px;
  height: 60px;
  background: ${props => props.theme.colors.pacific.base};
  position: absolute;
  bottom: 0;
  right: 5%;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.xs`
    right: 10%;
  `}
`

const Band = styled.div`
  width: 108.6666%;
  height: 60px;
  background: ${props => props.theme.colors.grey.lightest};
  position: absolute;
  bottom: 0;
`

class Grades extends Component {
  render() {
    const {
      optionsGradesLoading
    } = this.props

    const {
      heading,
      text,
      title9th,
      link9th,
      title10th,
      link10th,
      titlePro,
      linkPro,
    } = this.props.optionsGrades
    
    if (optionsGradesLoading) return null
    
    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
          <Container fluid>
            <Row>
              <Col
                sm={6}
                smOffset={3}
              >
                <Title>{heading}</Title>
              </Col>
              <Col
                sm={6}
                smOffset={3}
              >
                <Text>{text}</Text>
              </Col>
            </Row>
            <Content>
              <Row>
                <Col sm={4}>
                  <Grade to={getRelativeUrl(link9th)}>
                    <Heading>{title9th}</Heading>
                    <ImageContainer>
                      <Button>
                        <Arrow />
                      </Button>
                      <Icon9 />
                      <img src={stroke9} alt=""/>
                      <Band />
                    </ImageContainer>
                  </Grade>
                </Col>
                <Col sm={4}>
                  <Grade to={getRelativeUrl(link10th)}>
                    <Heading>{title10th}</Heading>
                    <ImageContainer>
                      <Button>
                        <Arrow />
                      </Button>
                      <Icon10 />
                      <img src={stroke10} alt=""/>
                      <Band />
                    </ImageContainer>
                  </Grade>
                </Col>
                <Col sm={4}>
                  <Grade to={getRelativeUrl(linkPro)}>
                    <Heading>{titlePro}</Heading>
                    <ImageContainer>
                      <Button>
                        <Arrow />
                      </Button>
                      <IconPro />
                      <img src={strokePro} alt=""/>
                      <Band />
                    </ImageContainer>
                  </Grade>
                </Col>
              </Row>
            </Content>
          </Container>
        </Wrapper>
      </InViewMonitor>
    )
  }
}

export default withQuery(() => gql`
  {
    optionsGrades {
      heading
      text
      title9th
      link9th
      title10th
      link10th
      titlePro
      linkPro
    }
  }
`, 'optionsGrades')(Grades)



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grades/index.js